// @flow

import React from 'react';
import Bubble, { Title, Item } from './bubble.styled';

type Props = {
  title: string,
  text: Array<string> | string,
};

export default ({ title, text }: Props) => (
  <Bubble>
    <Title>{title}</Title>
    {Array.isArray(text) && text.map((value, index) => {
      const key = `bubble-item-${index}`;
      return (
        <Item key={key}>{value}</Item>
      );
    })}
    {!Array.isArray(text) && (
      <div dangerouslySetInnerHTML={{ __html: text }} /> // eslint-disable-line react/no-danger
    )}
  </Bubble>
);
